import { resolveMediaUrl, resolveMediaList } from './mediaHelpers';

export const projectImage = (path) =>
  path ? `${process.env.PUBLIC_URL}/assets/images/${path}` : null;

export const displayProjectImage = (src) => {
  if (!src) return null;
  if (typeof src === 'string' && (src.startsWith('http') || src.startsWith('/'))) {
    return src;
  }
  return projectImage(src);
};

const lineList = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === 'string') {
    return value
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);
  }
  return [];
};

export const mapProjectListItem = (project) => ({
  id: project.documentId,
  title: project.title,
  category: project.category,
  slug: project.slug,
  image:
    resolveMediaUrl(project.coverImage) ||
    (project.coverImagePath ? projectImage(project.coverImagePath) : null),
  link: `/projects/${project.slug}`,
});

const splitSummary = (text) => {
  const parts = (text || '')
    .split(/\n\s*\n/)
    .map((part) => part.trim())
    .filter(Boolean);

  return {
    lead: parts[0] || '',
    closing: parts.slice(1).join('\n\n'),
  };
};

export const mapProjectDetail = (project) => {
  const uploadedSlides = resolveMediaList(project.sliderImages);
  const legacySlides = lineList(project.sliderImagePaths);

  const goalsParts = splitSummary(project.goalsSummary);
  const outcomeParts = splitSummary(project.outcomeSummary);

  const sliderImages = uploadedSlides.length
    ? uploadedSlides
    : legacySlides.map((path) => projectImage(path)).filter(Boolean);

  return {
    title: project.title,
    subtitle: project.subtitle || '',
    sliderImages,
    skills: project.skills || '',
    client: project.client || '',
    completedDate: project.completedDate || '',
    location: project.location || '',
    intro: project.intro || '',
    intro2: project.intro2 || '',
    goals: lineList(project.goalBullets || project.goals),
    goalsSummary: goalsParts.lead,
    goalsClosing: goalsParts.closing,
    goalImage:
      resolveMediaUrl(project.goalImage) ||
      displayProjectImage(project.goalImagePath),
    outcomeImage:
      resolveMediaUrl(project.outcomeImage) ||
      displayProjectImage(project.outcomeImagePath || project.coverImagePath),
    outcomes: lineList(project.outcomeBullets || project.outcomes),
    outcomeSummary: outcomeParts.lead,
    outcomeClosing: outcomeParts.closing,
  };
};
